import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { Phone, Mail, Globe } from "lucide-react";

interface SupportInfoStepProps {
  form: UseFormReturn<any>;
}

export const SupportInfoStep = ({ form }: SupportInfoStepProps) => {
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-2">Support Information</h2>
        <p className="text-muted-foreground">
          Provide contact details users can access during enrollment
        </p>
      </div>

      <Card disableHover>
        <CardHeader>
          <CardTitle className="text-lg">Contact Details (Optional)</CardTitle>
          <CardDescription>
            These details will be displayed to users during device setup
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <FormField
            control={form.control}
            name="support_phone_number"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-muted-foreground" />
                  Support Phone Number
                </FormLabel>
                <FormControl>
                  <Input 
                    placeholder="+1 (555) 123-4567" 
                    {...field}
                  />
                </FormControl>
                <FormDescription>
                  Phone number for users to call for setup assistance
                </FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="support_email_address"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="flex items-center gap-2">
                  <Mail className="h-4 w-4 text-muted-foreground" />
                  Support Email Address
                </FormLabel>
                <FormControl>
                  <Input 
                    type="email"
                    placeholder="support@company.com" 
                    {...field}
                  />
                </FormControl>
                <FormDescription>
                  Email address for enrollment support inquiries
                </FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="configuration_web_url"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="flex items-center gap-2">
                  <Globe className="h-4 w-4 text-muted-foreground" />
                  Configuration Web URL
                </FormLabel>
                <FormControl>
                  <Input 
                    type="url"
                    placeholder="https://support.company.com/setup" 
                    {...field}
                  />
                </FormControl>
                <FormDescription>
                  Web page with enrollment instructions or documentation
                </FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
        </CardContent>
      </Card>
    </div>
  );
};
